import React, { /*useEffect,useRef,*/ useState } from 'react'
import { ArrowLeft, Store, User, Mail, Phone, Loader } from 'lucide-react'
import apiService from '../../services/apiService'
import './AuthFlow.scss'
import authService from '../../services/authService'
// const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITEKEY

const Register = ({ onBack, onRegisterDataReady }) => {
  const [formData, setFormData] = useState({
    shopName: '',
    ownerName: '',
    email: '',
    phone: '',
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  // const widgetIdRef = useRef(null)
  // const tokenRef = useRef(null)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  // useEffect(() => {
  //   if (!document.getElementById('cf-turnstile')) {
  //     const s = document.createElement('script')
  //     s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
  //     s.id = 'cf-turnstile'
  //     s.async = true
  //     s.defer = true
  //     document.body.appendChild(s)
  //   }
  // }, [])

  // useEffect(() => {
  //   let mounted = true
  //   const tryRender = () => {
  //     if (!mounted) return
  //     if (!window.turnstile) {
  //       setTimeout(tryRender, 300)
  //       return
  //     }
  //     let container = document.getElementById('turnstile-container')
  //     if (!container) {
  //       container = document.createElement('div')
  //       container.id = 'turnstile-container'
  //       document.getElementById('turnstile-root').appendChild(container)
  //     }
  //     widgetIdRef.current = window.turnstile.render(container, {
  //       sitekey: SITE_KEY,
  //       callback: (token) => {
  //         tokenRef.current = token
  //       },
  //       'error-callback': () => {
  //         tokenRef.current = null
  //       },
  //       'expired-callback': () => {
  //         tokenRef.current = null
  //       },
  //     })
  //   }
  //   tryRender()
  //   return () => {
  //     mounted = false
  //   }
  // }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    const connected = await authService.isOnline()
    if (!connected) {
      setError('Votre connexion Internet semble interrompue.')
      setLoading(false)
    } else {
      try {
        // if (
        //   !tokenRef.current &&
        //   window.turnstile &&
        //   widgetIdRef.current !== null
        // ) {
        //   try {
        //     window.turnstile.reset(widgetIdRef.current)
        //     await new Promise((r) => setTimeout(r, 700))
        //   } catch {}
        // }
        // const turnstileToken = tokenRef.current
        // if (!turnstileToken) {
        //   setError('Impossible de vérifier le captcha.')
        //   setLoading(false)
        //   return
        // }

        const response = await apiService.requestRegisterCodes(
          formData.email,
          formData.phone,
          // turnstileToken,
        )

        if (response.success) {
          onRegisterDataReady(formData)
        } else {
          setError(response.error || "Erreur lors de l'envoi des codes")
        }
      } catch (err) {
        setError('Erreur de connexion. Vérifiez votre connexion internet.')
      } finally {
        setLoading(false)
        // tokenRef.current = null
        // if (window.turnstile && widgetIdRef.current !== null)
        //   try {
        //     window.turnstile.reset(widgetIdRef.current)
        //   } catch (e) {}
      }
    }
  }

  return (
    <div className='auth-container'>
      <div className='auth-header'>
        <button onClick={onBack} className='btn-back'>
          <ArrowLeft size={20} />
        </button>
        <h1 className='auth-title'>
          OGC<span style={{ color: 'red' }}>2</span>
          <span style={{ color: 'rgb(255, 255, 42)' }}>2</span>
          <span style={{ color: '#00d700' }}>4</span>
        </h1>
      </div>

      <div className='auth-card'>
        <h2 className='auth-card-title'>Créer un compte</h2>
        <p className='auth-card-subtitle'>
          Remplissez les informations de votre boutique
        </p>

        <form onSubmit={handleSubmit} className='auth-form'>
          <div className='form-field'>
            <label
              style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Store size={16} /> Nom de la boutique *
            </label>
            <input
              type='text'
              name='shopName'
              value={formData.shopName}
              onChange={handleChange}
              placeholder='Ex: Fashion & Style Shop'
              required
              disabled={loading}
            />
          </div>

          <div className='form-field'>
            <label
              style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <User size={16} /> Nom complet du représentant *
            </label>
            <input
              type='text'
              name='ownerName'
              value={formData.ownerName}
              onChange={handleChange}
              placeholder='Ex: Aboubacar Camara'
              required
              disabled={loading}
            />
          </div>

          <div className='form-field'>
            <label
              style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Mail size={16} /> Adresse email *
            </label>
            <input
              type='email'
              name='email'
              value={formData.email}
              onChange={handleChange}
              placeholder='exemple@email.com'
              required
              disabled={loading}
            />
          </div>

          <div className='form-field'>
            <label
              style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Phone size={16} /> Numéro de téléphone *
            </label>
            <input
              type='tel'
              name='phone'
              value={formData.phone}
              onChange={handleChange}
              placeholder='+224610101010'
              required
              disabled={loading}
            />
          </div>

          <div id='turnstile-root' style={{ display: 'none' }} />
          {error && <div className='auth-error'>{error}</div>}

          <button
            type='submit'
            className='btn primary lg full'
            disabled={loading}
          >
            {loading ? (
              <>
                <Loader size={20} className='btn-icon spinning' />
                Envoi en cours...
              </>
            ) : (
              'Continuer'
            )}
          </button>
        </form>
      </div>

      <div className='auth-footer'>
        Besoin d'aide ? Contactez-nous sur WhatsApp au{' '}
        <span
          onClick={() => {
            window.open('https://wa.me/224621994206', '_blank')
          }}
        >
          +224 621 99 42 06
        </span>
      </div>
    </div>
  )
}

export default Register
